// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"a2f63a6f","467":"b6b15aa6"}[chunkId] + ".chunk.css";
};